import { url } from '@exodus/fetch/url';
const SERVER = new URL('https://api.changenow.io/v1');
const KEY = new Map([
    ['intl', 'ce36516d2e4a173d882aab34d0c63307806f3178e355df4c27eaee2ebc948a5c'],
    ['us', 'bae05202b42b05cf62d90a9d7e86c1842d546205724d5b6fd729c07a8da6954d'],
]);
const createGetChangeNowOrder = (geolocation, fetchival) => async (id) => {
    return fetchival(url `${SERVER}/transactions/${id}/${KEY.get(geolocation)}`).get();
};
const createGetProviderOrder = (geolocation) => async (providerOrder, fetchival) => {
    const orderInfo = await createGetChangeNowOrder(geolocation, fetchival)(providerOrder.id);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.payinAddress,
        depositAmount: String(orderInfo.expectedSendAmount),
        withdrawalAddress: orderInfo.payoutAddress,
    };
};
const changeNowConfig = {
    cn: createGetProviderOrder('intl'),
    cnus: createGetProviderOrder('us'),
};
export default changeNowConfig;
